<template>
  <div ref="popoverZmrMenuRef" class="popover-zmr-menu" @mouseenter="showPopover">
    <div v-if="props.parentItem !== ''" class="popover-zmr-menu-item-p" style="border-bottom: 1px solid #e6e6e6;">
      <div style="width: 100%;display: flex;align-items: center">
        <div class="popover-zmr-menu-item-icon"
             v-if="props.parentItem.icon !== undefined && props.parentItem.icon !== ''">
          <zmrIcon :name="props.parentItem.icon"></zmrIcon>
        </div>
        <div>{{ props.parentItem[itemProps.title] }}</div>
      </div>
      <div class="popover-zmr-sub-menu-title-arrow">
        <i class="iconfont zmr_icon_i icon-zhankai"></i>
      </div>
    </div>
    <template v-for="(item,index) in props.data">
      <div @mouseenter="mouseenterFun(index)" @mouseleave="mouseleaveFun" @click="menuItemClick(item,index)"
           v-if="item.children === undefined || item.children.length <= 0"
           :key="index" class="popover-zmr-menu-item" :class="Number(activeIndex) === Number(index)?'active':''">
        <div class="popover-zmr-menu-item-icon" v-if="item.icon !== undefined && item.icon !== ''">
          <zmrIcon :name="item.icon"></zmrIcon>
        </div>
        <div>{{ item[itemProps.title] }}</div>
      </div>
      <div v-if="item.children !== undefined && item.children.length > 0" :key="index" class="popover-zmr-menu-item" :class="Number(activeIndex) === Number(index)?'active':''"
           @mouseenter="mouseenterFun(index)" @mouseleave="mouseleaveFun" @click="menuItemClick(item,index)">
        <div style="width: 100%;display: flex;align-items: center">
          <div class="popover-zmr-menu-item-icon" v-if="item.icon !== undefined && item.icon !== ''">
            <zmrIcon :name="item.icon"></zmrIcon>
          </div>
          <div>{{ item[itemProps.title] }}</div>
          <div class="popover-zmr-sub-menu-title-arrow">
            <i class="iconfont zmr_icon_i icon-jinru"></i>
          </div>
        </div>
        <popoverZmrMenu
            ref="zmrMenuChildrenRef"
            v-show="openIndex === index"
            class="zmr-popover-menu-content"
            :data="item.children"
            :defaultActive="props.defaultActive"
            :router="props.router"
            :menuProps="props.menuProps"
            :bgColor="props.bgColor"
            :textColor="props.textColor"
            :activeBgColor="props.activeBgColor"
            :activeColor="props.activeColor"
            :hoverBgColor="props.hoverBgColor"
            :hoverColor="props.hoverColor"
            :isBackParent="props.isBackParent"
            :parentIndex="Number(index)"
            @show="showPopover"
            @menuClick="menuClickFun"
        ></popoverZmrMenu>
      </div>
    </template>
  </div>
</template>

<script setup>
import zmrIcon from '../base/zl-icon.vue'
import popoverZmrMenu from './popover_zmr_menu.vue'
import {ref, onMounted, watch,computed} from 'vue'
import {useRouter} from 'vue-router'
import {useStore} from 'vuex'
import {isNotEmpty} from "../../common/js/comjs";

const store = useStore();
const router = useRouter();
const props = defineProps({
  data: {
    type: Array,
    default: new Array([])
  },
  isCollapse: {
    type: Boolean,
    default: false
  },
  defaultActive: {
    default: ''
  },
  uniqueOpened: {
    type: Boolean,
    default: false
  },
  router: {
    type: Boolean,
    default: false
  },
  menuProps: {
    type: Object,
    default: new Object({})
  },
  level: {
    type: Number,
    default: 0
  },
  bgColor: {
    type: String,
    default: ''
  },
  textColor: {
    type: String,
    default: ''
  },
  activeBgColor: {
    type: String,
    default: ''
  },
  activeColor: {
    type: String,
    default: ''
  },
  hoverBgColor: {
    type: String,
    default: ''
  },
  hoverColor: {
    type: String,
    default: ''
  },
  isBackParent: {
    type: Boolean,
    default: false
  },
  parentIndex: {
    type: Number
  },
  parentItem: {
    default: ''
  },
  iconTop: {
    default: 0
  }
});
const emit = defineEmits(['menuClick', 'hide', 'show']);
const openIndex = ref('');
const activeItem = ref({});
const activeIndex = ref(-1);
const zmrMenuChildrenRef = ref(null);
const timeIndex = ref(null);
const itemProps = ref({
  id: 'id',
  title: 'name',
  path: 'path',
  icon: 'icon'
});

if (JSON.stringify(props.menuProps) !== '{}') {
  let menuProps = computed(()=>{
    return props.menuProps;
  })
  for (let i in menuProps) {
    if (itemProps.value[i] !== undefined && menuProps[i] !== null && menuProps[i] !== '') {
      itemProps.value[i] = menuProps[i];
    }
  }
}

watch(() => props.iconTop, (newData, oldData) => {
  if (newData !== oldData) {
    document.documentElement.style.setProperty('--zl-menu-indicate-icon-top', newData);
  }
})

watch(() => store.state.activeMenuId, (newData, oldData) => {
  if (newData !== oldData) {
    setDefaultActive(store.state.activeMenuId);
  }
})

onMounted(() => {
  if(isNotEmpty(props.defaultActive)){
    setDefaultActive(props.defaultActive);
  }else{
    if(isNotEmpty(store.state.activeMenuId)){
      setDefaultActive(store.state.activeMenuId);
    }
  }
  if (props.bgColor !== '') {
    document.documentElement.style.setProperty('--zl-menu-bg-color', props.bgColor);
  }
  if (props.textColor !== '') {
    document.documentElement.style.setProperty('--zl-menu-text-color', props.textColor);
  }
  if (props.activeColor !== '') {
    document.documentElement.style.setProperty('--zl-menu-active-color', props.activeColor);
  }
  if (props.activeBgColor !== '') {
    document.documentElement.style.setProperty('--zl-menu-active-bg-color', props.activeBgColor);
  }
  if (props.hoverColor !== '') {
    document.documentElement.style.setProperty('--zl-menu-hover-color', props.hoverColor);
  }
  if (props.hoverBgColor !== '') {
    document.documentElement.style.setProperty('--zl-menu-hover-bg-color', props.hoverBgColor);
  }
})

//设置默认值
const setDefaultActive = (activeData) => {
  if (isNotEmpty(activeData)) {
    for (let i in props.data) {
      let dataItem = props.data[i];
      if (isNotEmpty(dataItem[itemProps.value.id]) && String(dataItem[itemProps.value.id]) === String(activeData)) {
        activeIndex.value = Number(i);
        activeItem.value = dataItem;
        if (!props.isCollapse) {
          emit('show', dataItem, props.parentIndex)
        }
        break;
      }
    }
  }
}

//鼠标移入
const mouseenterFun = (index) => {
  openIndex.value = index;
}

//鼠标移除气泡框
const showPopover = () => {
  if (timeIndex.value !== null) {
    clearInterval(timeIndex.value);
    timeIndex.value = null;
  }
  emit('show');
}

//菜单点击
const menuItemClick = (item, index) => {
  activeItem.value = item;
  activeIndex.value = index;
  if (props.router) {
    if (item[itemProps.value.path] !== undefined && item[itemProps.value.path] !== null && item[itemProps.value.path] !== '') {
      //设置页面的按钮权限
      if (isNotEmpty(item.children) && item.children.length > 0) {
        let rank = [];
        for (let i in item.children) {
          let iData = item.children[i];
          if (iData.menuType === 'action' && isNotEmpty(iData.code)) {
            rank.push(iData.code);
          }
        }
        store.commit('setPageRank', rank);
      }
      //设置选中菜单
      store.commit('commitSetMenu', item);
      //设置路由跳转
      router.push({
        path: item[itemProps.value.path]
      })
    }
  }
  if (props.isBackParent) {
    emit('menuClick', [item], props.parentIndex);
  } else {
    emit('menuClick', item, props.parentIndex);
  }
}

//监听子集点击返回
const menuClickFun = (data) => {
  activeItem.value = {};
  activeIndex.value = -1;
  if (props.isBackParent) {
    let returnData = data;
    if (openIndex.value !== '') {
      if (isNotEmpty(props.data[openIndex.value])) {
        let parentData = JSON.parse(JSON.stringify(props.data[openIndex.value]));
        if (isNotEmpty(parentData.children)) {
          parentData.children = [];
          returnData.unshift(parentData)
        }
      }
    }
    emit('menuClick', returnData, props.parentIndex);
  } else {
    emit('menuClick', data, props.parentIndex);
  }
}
//从父级清除子集的选中
const clearActive = (isClear, removeIndex = '') => {
  if (isClear !== undefined && isClear) {
    activeItem.value = {};
    activeIndex.value = -1;
  }
  if (zmrMenuChildrenRef.value !== null) {
    for (let i in zmrMenuChildrenRef.value) {
      if (isNotEmpty(removeIndex) && Number(i) === Number(removeIndex)) {
        continue;
      }
      zmrMenuChildrenRef.value[i].clearActive(true, '');
    }
  }
}
defineExpose({clearActive})

</script>

<style scoped lang="less">
.popover-zmr-menu {
  background-color: var(--zl-menu-bg-color);
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3));
  width: 250px;
  border-radius: 4px;
  position: relative;

  .popover-zmr-menu-item-p {
    cursor: pointer;
    color: var(--zl-menu-text-color);
    padding-top: calc(var(--zl-menu-padding) - 3px);
    padding-bottom: calc(var(--zl-menu-padding) - 3px);
    padding-left: var(--zl-menu-padding);
    padding-right: calc(var(--zl-menu-padding) + 5px);
    display: flex;
    align-items: center;
    position: relative;

    .popover-zmr-menu-item-icon {
      width: 18px;
      height: 18px;
      line-height: 18px;
      font-size: 18px;
      margin-right: 5px;

      img {
        width: 100%;
        height: 15px;
      }
    }

    .popover-zmr-sub-menu-title-arrow {
      position: absolute;
      right: 5px;
      top: calc(50% - 6px);
      color: var(--zl-menu-text-color);
      font-size: 12px;
      width: 12px;
      height: 12px;
      line-height: 12px;
    }
  }

  .popover-zmr-menu-item {
    margin: 5px 0;
    cursor: pointer;
    color: var(--zl-menu-text-color);
    padding-top: calc(var(--zl-menu-padding) - 3px);
    padding-bottom: calc(var(--zl-menu-padding) - 3px);
    padding-left: var(--zl-menu-padding);
    padding-right: calc(var(--zl-menu-padding) + 5px);
    display: flex;
    align-items: center;
    position: relative;

    .popover-zmr-menu-item-icon {
      width: 18px;
      height: 18px;
      line-height: 18px;
      font-size: 18px;
      margin-right: 5px;

      img {
        width: 100%;
        height: 15px;
      }
    }

    .popover-zmr-sub-menu-title-arrow {
      position: absolute;
      right: 5px;
      top: calc(50% - 6px);
      color: var(--zl-menu-text-color);
      font-size: 12px;
      width: 12px;
      height: 12px;
      line-height: 12px;
    }

    .zmr-popover-menu-content {
      position: absolute;
      top: 0;
      left: 260px;
      z-index: 2222;
    }
  }

  .active {
    position: relative;
    background-color: var(--zl-menu-active-bg-color);
    color: var(--zl-menu-active-color);
    font-weight: 600;
  }

  .popover-zmr-menu-item:hover {
    background-color: var(--zl-menu-hover-bg-color);
    color: var(--zl-menu-hover-color);
  }
}

.popover-zmr-menu::before {
  position: absolute;
  background-color: var(--zl-menu-bg-color);
  width: 10px;
  height: 10px;
  top: var(--zl-menu-indicate-icon-top);
  left: -4px;
  border-radius: 2px;
  content: '';
  display: inline-block;
  transform: rotate(45deg);
}
</style>
